// Faixas de tempo de inscrição na OAB/PR que abrem o modal de verificação
// inline (issue jor-380/issue-03). O backend (useCases/CheckoutValidation/caaPartnerRules.ts)
// já resolve a faixa/elegibilidade a partir do CPF/data de inscrição vindos da consulta à OAB-PR;
// aqui só precisamos saber quais dois cupons de entrada disparam essa consulta.
export const CAA_PR_SPECIAL_COUPONS = [
  'CAAPR_ESPECIAL_JUSMAIL',
  'CAAPR_ESPECIAL_6A10_JUSMAIL_PROMOCIONAL',
] as const;

// Entrada no catálogo base com desconto de parceria, aplicada quando o
// registro é encontrado mas fora das duas faixas especiais.
export const CAA_PR_BASE_ENTRY_COUPON = 'CAAPR_ONE';

// Benefício de entrada garantido quando a pessoa segue sem o cupom especial
// (registro não encontrado, consulta indisponível, ou fechamento antecipado do modal).
export const CAA_PR_DEGUSTACAO_COUPON = 'CAAPR_DEGUSTACAO';

export function isCaaPrSpecialCoupon(coupon?: string | null): boolean {
  if (!coupon) {
    return false;
  }
  return (CAA_PR_SPECIAL_COUPONS as readonly string[]).includes(coupon.toUpperCase());
}
